import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { Payment } from './components/Payment'
import { PaymentSuccess } from './components/PaymentSuccess'

export const Anonymous: React.FC = () => {
  return (
    <Routes>
      <Route path="/payment" element={<Payment />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
    </Routes>
  )
}